import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Dropdown } from 'react-bootstrap';

import jiraCloudIcon from '../assets/images/integrations/jira-cloud.svg';
import openInNewIcon from '../assets/img/open-in-new-blue.svg';
import arrowIcon from '../assets/img/arrow-dropup-blue.svg';

export class SourceDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  toggle = open => this.setState({ open });

  render() {
    const { source, hint, children } = this.props;
    const { open } = this.state;
    return (
      <Dropdown className="next_sync_source" show={open} onToggle={this.toggle}>
        <OverlayTrigger placement="bottom" show={open ? false : undefined} overlay={hint}>
          <Dropdown.Toggle as="button" className="next_sync source">
            {children}
            <img src={arrowIcon} alt="" className="source_arrow" />
          </Dropdown.Toggle>
        </OverlayTrigger>
        <Dropdown.Menu className="source_panel">
          <div className="source_head">
            <img src={jiraCloudIcon} alt="" />
            <h4>Dashboard data source</h4>
          </div>
          <div className="source_row">
            <span className="source_label">Board</span>
            <span className="source_value">{source.board}</span>
          </div>
          <div className="source_row">
            <span className="source_label">Project</span>
            <span className="source_value">{source.project}</span>
          </div>
          {!!source.url && (
            <a className="source_open" href={source.url} target="_blank" rel="noopener noreferrer">
              Open in Jira
              <img src={openInNewIcon} alt="" />
            </a>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

SourceDropdown.propTypes = {
  source: PropTypes.shape({
    board: PropTypes.string,
    project: PropTypes.string,
    url: PropTypes.string,
  }),
  hint: PropTypes.element,
  children: PropTypes.node,
};
